export default (function (event) {
  return event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;
});